import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as firebase from 'firebase/app';

@Injectable()
export class AuthService {

  userObj: FirebaseObjectObservable<any>;
  public userIdentifier: string;
  public isLoggedIn = new BehaviorSubject(null);
  public isLoggingIn = true;
  public userIsSuperUser = new BehaviorSubject(null);

  public users = {};

  constructor(public afAuth: AngularFireAuth, private af: AngularFireDatabase) {
    this.afAuth.authState.subscribe(auth => {
      this.isLoggingIn = false;

      if(!auth || !auth.uid) {
        console.log("Not logged in");
        this.isLoggedIn.next(false);
      }

      else {
        // Grab our primary user obj and identifier and cache them
        this.userObj = af.object('/users/'+auth.uid);
        this.userIdentifier = auth.uid;
        this.users[this.userIdentifier] = this.userObj;

        this.userObj.update({
          name: auth.displayName,
          email: auth.email,
          imageURL: auth.photoURL,
          type: auth.providerId
        });

        this.userObj.$ref.transaction(snapshot => {
          if(!snapshot.score) {
            snapshot.score = 1000;
          }
          return snapshot;
        });

        this.isLoggedIn.next(true);
        console.log("Logged in");

        this.userObj.subscribe( user => {
          if(user.powers && user.powers.superuser) {
            console.log("Hello, Quibbl team member!");
            this.userIsSuperUser.next(true);
          }
        });
      }

    });
  }

  public getUser(identifier) {
    if(this.users[identifier]) {
      return this.users[identifier];
    }

    let newUser = this.af.object('/users/'+identifier);
    this.users[identifier] = newUser;
    return newUser;
  }

  public getLeaderboard(category: string, callout: string, limit: number) {
    let child = 'score';
    if(category && !callout) {
      child = category + "Score";
    }

    else if(category && callout) {
      child = category + "Score_" + callout;
    }

    return this.af.list('/users', {
      query: {
        orderByChild: child,
        limitToLast: limit
      }
    });
  }

  public getUsers(limit: number) {
    return this.af.list('/users', {
      query: {
        orderByChild: 'score',
        limitToLast: limit
      }
    });
  }

  public getUserTrophies(user: string) {
    return this.af.list('/users/' + user + '/trophies');
  }

  public loginWithGoogle() {
    this.afAuth.auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider()).catch(function(error) {
      console.log(error);
    });
  }

  public loginWithFacebook() {
    this.afAuth.auth.signInWithRedirect(new firebase.auth.FacebookAuthProvider()).catch(function(error) {
      console.log(error);
    });
  }

  public logout() {
     this.afAuth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/auth.service.ts